<template>
  <div>
    <el-tooltip
      class="item"
      effect="dark"
      placement="top"
      :content="getTooltipContent()"
      :hide-after="3000"
    >
      <i v-if="error" class="el-icon-warning" :style="`color: ${color}`"></i>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: "RouteErrorTooltip",

  props: {
    error: {
      type: Number,
      default: 0
    },
    color: {
      type: String,
      default: "#000000"
    }
  },

  methods: {
    getTooltipContent() {
      if (this.error === 1) {
        return this.$t("tooltip.routeTimeout");
      } else if (this.error === 2 || this.error === 3 || this.error === 5) {
        return this.$t("tooltip.routeWrongPath");
      } else if (this.error === 4) {
        return this.$t("tooltip.routeOffline");
      } else if (this.error === 6) {
        return this.$t("tooltip.routeInterrupted");
      } else if (this.error === 7) {
        return this.$t("tooltip.routeMinDuration");
      } else if (this.error > 7) {
        return this.$t("tooltip.unknownError");
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
